import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appNoSpaces]',
    standalone: false
})
export class NoSpacesDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/\s/g, '');
    this.ngControl.control?.setValue(sanitizedValue, { emitEvent: false });
  }
}
